<ey-froala-content-wrapper [editorContent]="body"></ey-froala-content-wrapper>
